import React from 'react';
import { Chip, CopyIcon, CheckIcon } from '@forge/common';

export interface ActivityCopyableChipProps {
  label: string;
  isCopied: boolean;
  onClick: () => void;
  testId?: string;
}

const ActivityCopyableChip: React.FC<ActivityCopyableChipProps> = ({ label, isCopied, onClick, testId }) => {
  return (
    <Chip
      onClick={onClick}
      data-testid={testId}
      size="small"
    >
      <span className="tw-inline-flex tw-items-center tw-gap-2 tw-cursor-pointer">
        <span>{label}</span>
        <span className="tw-w-4 tw-h-4 tw-flex tw-items-center tw-justify-center">
          {isCopied ? <CheckIcon strokeWidth={2} /> : <CopyIcon strokeWidth={2} />}
        </span>
      </span>
    </Chip>
  );
};

export default React.memo(ActivityCopyableChip);
